//TODO REMOVE

export function getSessionLocationFromUrl(defaultLocation?: string) {
  return getLocationFromUrl(defaultLocation)
    ? {
        name: getLocationFromUrl(defaultLocation)?.name,
        value: getLocationFromUrl(defaultLocation)?.value,
        hotelId: window.QW_HOTEL_ENV.HOTEL_ID,
        engineId: window.QW_HOTEL_ENV.ENGINE_ID,
      }
    : undefined;
}

export function getLocationFromUrl(defaultLocation?: string) {
  const locations = JSON.parse(defaultLocation)?.hostel;
  const urlLocationMatch = locations.find((l) =>
    location.href.includes(l.value),
  );
  if (urlLocationMatch) {
    return urlLocationMatch;
  } else {
    return undefined;
  }
}
